const messages = {
    name: "Nat Bates",
};

export default messages;
